import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import TagsManagerView from '../../../Tags/manager/TagsManagerView';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../../Tags/styles/index.scss';

const CreateImpressionsTag = ({
  onSubmit = () => {}, //Function to be called when the modal is submitted
  advertisers,
}) => {
  const [visible, setVisible] = useState(false); //Modal Pop up

  return (
    <React.Fragment>
      <Button
        type="primary"
        shape="round"
        onClick={() => {
          setVisible(true);
        }}
      >
        Create Impression Tag
      </Button>

      <Modal
        title="Create Impression Tag"
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
        wrapClassName="tags-modal"
        width={modal.wide}
        centered
      >
        <TagsManagerView
          headerSubmit={false}
          tagType={'Impression'}
          platforms={advertisers}
          onCard={false}
          onCancel={() => setVisible(false)}
          onSubmit={async (value) => {
            await onSubmit(value);
            setVisible(false);
          }}
        />
      </Modal>
    </React.Fragment>
  );
};

export default CreateImpressionsTag;
